// components/layout/Layout.js

import React from 'react';
import Header from './Header';
import Player from '../common/Player';
import { useApp } from '../../context/AppContext';

const Layout = ({ children }) => {
    const { currentTrack } = useApp();

    return (
        <div className="app-wrapper">
            <Header />
            <main className="main-content">
                {children}
            </main>
            {currentTrack && <Player />}
        </div>
    );
};

export default Layout;